export const UZBEK_LATIN_LOCALE = 'uz'
export const UZBEK_CYRILLIC_LOCALE = 'uz-Cyrl'

export function canonicalizeUzbekLocale(value) {
  if (typeof value !== 'string') {
    return null
  }

  const compactLocale = value.trim().replace(/[-_]/g, '').toLowerCase()

  if (/^uzcyrl(?:uz)?$/.test(compactLocale)) {
    return UZBEK_CYRILLIC_LOCALE
  }

  if (/^uz(?:latn)?(?:uz)?$/.test(compactLocale)) {
    return UZBEK_LATIN_LOCALE
  }

  return null
}

export function canonicalizeLocale(value) {
  if (typeof value !== 'string') {
    return null
  }

  const locale = value.trim()
  if (!locale) {
    return null
  }

  const uzbekLocale = canonicalizeUzbekLocale(locale)
  if (uzbekLocale) {
    return uzbekLocale
  }

  return locale.replaceAll('_', '-').toLowerCase()
}

export function normalizeLocale(value, availableLocales) {
  const canonicalLocale = canonicalizeLocale(value)
  if (!canonicalLocale) {
    return null
  }

  if (!Array.isArray(availableLocales) || availableLocales.length === 0) {
    return canonicalLocale
  }

  const comparableLocale = canonicalLocale.toLowerCase()
  return availableLocales.find((locale) => canonicalizeLocale(locale)?.toLowerCase() === comparableLocale) || null
}

export function getAvailableBrowserLocale(languages, language, availableLocales) {
  const browserLocales = Array.isArray(languages) && languages.length > 0 ? languages : [language]

  for (const browserLocale of browserLocales) {
    const canonicalLocale = canonicalizeLocale(browserLocale)
    if (!canonicalLocale) {
      continue
    }

    const localeParts = canonicalLocale.split('-').filter(Boolean)
    const candidates = [canonicalLocale]

    if (localeParts.length > 2 && localeParts[1].length === 4) {
      candidates.push(localeParts.slice(0, 2).join('-'))
    }

    if (localeParts.length > 1) {
      candidates.push(localeParts[0])
    }

    for (const candidate of new Set(candidates)) {
      const locale = normalizeLocale(candidate, availableLocales)
      if (locale) {
        return locale
      }
    }
  }

  return null
}

export function getPrimaryBrowserLanguage(languages, language) {
  const primaryLocale = typeof language === 'string' && language.trim() ? language : languages?.[0]
  return canonicalizeLocale(primaryLocale)?.split('-')[0] || null
}

export function localeToApiLanguage(value) {
  const locale = canonicalizeLocale(value)
  return locale ? locale.replaceAll('-', '_').toUpperCase() : null
}

export function apiLanguageToLocale(value, availableLocales) {
  return normalizeLocale(value, availableLocales)
}
